// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html {
  scroll-behavior: smooth;
}
body {
  font-display: 'swap';
}
.Polaris-DatePicker__Day--disabled {
  background-color: #303030;
  color: white;
  outline: 0.0625rem solid transparent;
}
.Polaris-DatePicker__Day--disabled:hover {
  background-color: #303030;
  color: white;
  outline: 0.0625rem solid transparent;
}
select {
  padding-left: 0.5rem;
}
.Polaris-Icon {
  margin: 0;
}

.Polaris-Link#remove-hover-underline:hover {
  text-decoration: none;
}

.text--blue {
  color: #197cbd;
}

.text--error {
  color: var(--p-color-text-critical);
}

.text--lg {
  font-size: 0.9375rem;
}

.text-xl {
  font-size: 1.125rem;
}

.text--underline {
  text-decoration: underline;
}

.width-inherit {
  width: inherit;
}
.content-between {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.content-center {
  display: flex;
  width: 100%;
  justify-content: center;
}

.content-right {
  display: flex;
  width: 100%;
  justify-content: flex-end;
}
.Polaris-Label .Polaris-Label__Text {
  font-size: 0.75rem;
}

.cursor-pointer {
  cursor: pointer;
}

.disable {
  pointer-events: none;
  opacity: 0.7;
}
.divider {
  padding-bottom: 0.5rem;
  border-bottom: 1px #33333333 solid;
}
label {
  font-weight: 450;
}

.ml-4 {
  margin-left: 0.25rem;
}
.ml-8 {
  margin-left: 0.5rem;
}
.ml-16 {
  margin-left: 1rem;
}
.ml-32 {
  margin-left: 2rem;
}
.mr-4 {
  margin-right: 0.25rem;
}
.mr-8 {
  margin-right: 0.5rem;
}
.mr-16 {
  margin-right: 1rem;
}
.mt-4 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.125rem;
}
.mt-8 {
  margin-top: 0.5rem;
}
.mt-12 {
  margin-top: 0.75rem;
}
.mt-16 {
  margin-top: 1rem;
}
.mt-24 {
  margin-top: 1.5rem;
}

.mt-32 {
  margin-top: 2rem;
}

.mb-4 {
  margin-bottom: 0.25rem;
}
.mb-8 {
  margin-bottom: 0.5rem;
}
.mb-10 {
  margin-bottom: 0.625rem;
}
.mb-12 {
  margin-bottom: 0.75rem;
}
.mb-16 {
  margin-bottom: 1rem;
}
.my-16 {
  margin-top: 1rem;
  margin-bottom: 1rem;
}
.pl-8 {
  padding-left: 0.5rem;
}
.pl-16 {
  padding-left: 1rem;
}
.pb-8 {
  padding-bottom: 0.5rem;
}
.pd-16 {
  padding: 1rem;
}
.pr-8 {
  padding-right: 0.5rem;
}
.pr-8-i {
  padding-right: 0.5rem !important;
}
.p-16 {
  padding: 1rem;
}
.px-8 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-16 {
  padding-left: 1rem;
  padding-right: 1rem;
}

.py-16 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.pt-8 {
  padding-top: 0.5rem;
}

.pt-16 {
  padding-top: 1rem;
}

.d-inline-block {
  display: inline-block;
}
.d-flex {
  display: flex;
}
.flex-wrap {
  flex-wrap: wrap;
}
.inline-flex {
  display: inline-flex;
}
.flex-column-reverse {
  flex-direction: column-reverse;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.align-start {
  align-items: flex-start !important;
}

.text-start {
  text-align: start;
}

.text-center {
  text-align: center;
}

.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}

.child-flex-center > div {
  display: flex;
  align-items: center;
  justify-content: center;
}

.mx-4 {
  margin-left: 0.25rem;
  margin-right: 0.25rem;
}

.w-full {
  width: 100%;
}

.w-fit {
  width: fit-content;
}

.min-w-fit {
  min-width: fit-content;
}

.w-half {
  width: 50%;
}

.h-full {
  height: 100%;
}

.Polaris-TextField__Suffix {
  margin: 0;
  margin-right: 0.25rem;
}

.fw-500 {
  font-weight: 500;
}

.disable-content {
  opacity: 0.5;
  pointer-events: none;
}

.border-top {
  border-top: 1px solid #e7e7e7;
}

/* Editor image */
.tox-browse-url {
  display: none !important;
}

#emoji-close-div {
  display: none !important;
}

.editor-icon-container {
  display: flex;
  flex-wrap: wrap;
}

.editor-icon {
  display: flex;
  justify-content: center;
  padding: 4px;
  margin: 4px;
  width: 10%;
  cursor: pointer;
}
.editor-icon .est-emoji {
  height: 16px;
  width: 16px;
}
.editor-emoji-icon {
  color: #000;
  font-feature-settings: 'clig' off, 'liga' off;
  font-family: Inter;
  font-size: 20px;
  font-style: normal;
  font-weight: 450;
  line-height: 20px;
  font-display: swap;
}
label {
  font-weight: 450;
}
.note-group-select-from-files {
  display: none;
}

.Polaris-Listbox-TextOption__Checkbox {
  width: 100%;
}

.Polaris-Listbox-TextOption__Checkbox .Polaris-Choice.Polaris-Checkbox__ChoiceLabel {
  width: 100%;
}
.Polaris-Listbox-TextOption__Checkbox .Polaris-Choice.Polaris-Checkbox__ChoiceLabel .Polaris-Choice__Label {
  width: 100%;
}

.Polaris-Listbox-TextOption__Checkbox .Polaris-Choice.Polaris-Checkbox__ChoiceLabel .Polaris-Choice__Label > label {
  width: 100%;
}

.highlight-border {
  outline: 2px solid rgba(255, 184, 0, 0.56);
  animation: highlight-border 1.5s linear infinite;
  border-radius: 12px;
}

.bold-text-styled .Polaris-Text--root {
  font-size: 0.95rem;
}

.font-bold {
  font-weight: 700;
}

.ot-polaris-text-18 .Polaris-Text--root {
  font-size: 18px;
}

.gap-4 {
  gap: 0.25rem;
}

.gap-8 {
  gap: 0.5rem;
}

.gap-12 {
  gap: 0.75rem;
}

.gap-16 {
  gap: 1rem;
}

.gap-24 {
  gap: 1.5rem;
}

.text--gray {
  color: var(--p-color-text-disabled);
}

#btn-destructive-tone {
  background-color: var(--p-color-bg-fill-critical) !important;
}

#btn-destructive-tone:hover {
  background-color: var(--p-color-bg-fill-critical-hover) !important;
  color: #fff;
}

#btn-destructive-tone::before {
  box-shadow: var(--p-shadow-button-primary-critical) !important;
}

@keyframes highlight-border {
  0% {
    outline-color: #fff;
  }

  25% {
    outline-color: #ffb800;
  }

  75% {
    outline-color: #fff;
  }

  to {
    outline-color: #ffb800;
  }
}

/* Timeline graphic stage */
.inactive-stage {
  opacity: 0.5;
}

.timeline-actived-tab .Polaris-Button--tertiary {
  background-color: var(--pc-button-color-hover);
}

/* Text editor */

.item-highlight-outline {
  /* outline: 2px solid #005bd3; */
  outline: 2px solid #65abff;
  border-radius: 2px;
  &.border-radius-8 {
    border-radius: 8px;
  }
}

.text-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 500px;
}

.bg-gray {
  background-color: #f0f0f0 !important;
}

@media (max-width: 768px) {
  .text-ellipsis {
    max-width: 70vw;
  }
}

.Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge:has(#modal-cu-language-rule) {
  width: 95vw;
  max-width: unset;
}

@media (max-width: 768px) {
  .Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge:has(#modal-cu-language-rule) {
    width: 100vw;
    max-width: unset;
  }
}

.Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge:has(#language-rule-modal-title) {
  h2 {
    width: 100%;
  }
}

.Polaris-Modal-Dialog__Container:has(#editor-icon-container-id),
.Polaris-Modal-Dialog__Container:has(#language-rule-modal-discard-container),
.Polaris-Modal-Dialog__Container:has(#image-btn-in-editor),
.Polaris-Modal-Dialog__Container:has(#link-btn-in-editor),
.Polaris-Modal-Dialog__Container:has(#confirm-left-btn),
.Polaris-Modal-Dialog__Container:has(#editor-tips-template-container-id),
.Polaris-Modal-Dialog__Container:has(#confirm-auto-translate-content) {
  z-index: 520;
}

div:has(.Polaris-Modal-Dialog__Container):has(#editor-icon-container-id) + .Polaris-Backdrop,
div:has(.Polaris-Modal-Dialog__Container):has(#language-rule-modal-discard-container) + .Polaris-Backdrop,
div:has(.Polaris-Modal-Dialog__Container):has(#image-btn-in-editor) + .Polaris-Backdrop,
div:has(.Polaris-Modal-Dialog__Container):has(#link-btn-in-editor) + .Polaris-Backdrop,
div:has(.Polaris-Modal-Dialog__Container):has(#confirm-left-btn) + .Polaris-Backdrop,
div:has(.Polaris-Modal-Dialog__Container):has(#editor-tips-template-container-id) + .Polaris-Backdrop,
div:has(.Polaris-Modal-Dialog__Container):has(#confirm-auto-translate-content) + .Polaris-Backdrop {
  z-index: 519;
}

h2.Polaris-Text--root.Polaris-Text--headingMd.Polaris-Text--break:has(#cu-language-rule-modal-title) {
  width: 100%;
}

li.Polaris-Listbox-Option[aria-label='Select all dates'] > div {
  border-bottom: 1px solid #e0e0e0;
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,uBAAuB;AACzB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,oCAAoC;AACtC;AACA;EACE,oBAAoB;AACtB;AACA;EACE,SAAS;AACX;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;AACA;EACE,aAAa;EACb,WAAW;EACX,8BAA8B;AAChC;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,2BAA2B;AAC7B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,YAAY;AACd;AACA;EACE,sBAAsB;EACtB,kCAAkC;AACpC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;AACtB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,sBAAsB;AACxB;AACA;EACE,aAAa;AACf;AACA;EACE,qBAAqB;AACvB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,aAAa;AACf;AACA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;AACA;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,sBAAsB;AACxB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA,iBAAiB;AACjB;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,UAAU;EACV,eAAe;AACjB;AACA;EACE,YAAY;EACZ,WAAW;AACb;AACA;EACE,WAAW;EACX,6CAA6C;EAC7C,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;AACA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,0CAA0C;EAC1C,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,4DAA4D;AAC9D;;AAEA;EACE,kEAAkE;EAClE,WAAW;AACb;;AAEA;EACE,8DAA8D;AAChE;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA,2BAA2B;AAC3B;EACE,YAAY;AACd;;AAEA;EACE,8CAA8C;AAChD;;AAEA,gBAAgB;;AAEhB;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,kBAAkB;EAClB;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE;IACE,YAAY;IACZ,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;;;;;;;EAOE,YAAY;AACd;;AAEA;;;;;;;EAOE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gCAAgC;AAClC","sourcesContent":["html {\n  scroll-behavior: smooth;\n}\nbody {\n  font-display: 'swap';\n}\n.Polaris-DatePicker__Day--disabled {\n  background-color: #303030;\n  color: white;\n  outline: 0.0625rem solid transparent;\n}\n.Polaris-DatePicker__Day--disabled:hover {\n  background-color: #303030;\n  color: white;\n  outline: 0.0625rem solid transparent;\n}\nselect {\n  padding-left: 0.5rem;\n}\n.Polaris-Icon {\n  margin: 0;\n}\n\n.Polaris-Link#remove-hover-underline:hover {\n  text-decoration: none;\n}\n\n.text--blue {\n  color: #197cbd;\n}\n\n.text--error {\n  color: var(--p-color-text-critical);\n}\n\n.text--lg {\n  font-size: 0.9375rem;\n}\n\n.text-xl {\n  font-size: 1.125rem;\n}\n\n.text--underline {\n  text-decoration: underline;\n}\n\n.width-inherit {\n  width: inherit;\n}\n.content-between {\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-between {\n  justify-content: space-between;\n}\n.justify-start {\n  justify-content: flex-start;\n}\n.justify-end {\n  justify-content: flex-end;\n}\n.content-center {\n  display: flex;\n  width: 100%;\n  justify-content: center;\n}\n\n.content-right {\n  display: flex;\n  width: 100%;\n  justify-content: flex-end;\n}\n.Polaris-Label .Polaris-Label__Text {\n  font-size: 0.75rem;\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.disable {\n  pointer-events: none;\n  opacity: 0.7;\n}\n.divider {\n  padding-bottom: 0.5rem;\n  border-bottom: 1px #33333333 solid;\n}\nlabel {\n  font-weight: 450;\n}\n\n.ml-4 {\n  margin-left: 0.25rem;\n}\n.ml-8 {\n  margin-left: 0.5rem;\n}\n.ml-16 {\n  margin-left: 1rem;\n}\n.ml-32 {\n  margin-left: 2rem;\n}\n.mr-4 {\n  margin-right: 0.25rem;\n}\n.mr-8 {\n  margin-right: 0.5rem;\n}\n.mr-16 {\n  margin-right: 1rem;\n}\n.mt-4 {\n  margin-top: 0.25rem;\n}\n.mt-2 {\n  margin-top: 0.125rem;\n}\n.mt-8 {\n  margin-top: 0.5rem;\n}\n.mt-12 {\n  margin-top: 0.75rem;\n}\n.mt-16 {\n  margin-top: 1rem;\n}\n.mt-24 {\n  margin-top: 1.5rem;\n}\n\n.mt-32 {\n  margin-top: 2rem;\n}\n\n.mb-4 {\n  margin-bottom: 0.25rem;\n}\n.mb-8 {\n  margin-bottom: 0.5rem;\n}\n.mb-10 {\n  margin-bottom: 0.625rem;\n}\n.mb-12 {\n  margin-bottom: 0.75rem;\n}\n.mb-16 {\n  margin-bottom: 1rem;\n}\n.my-16 {\n  margin-top: 1rem;\n  margin-bottom: 1rem;\n}\n.pl-8 {\n  padding-left: 0.5rem;\n}\n.pl-16 {\n  padding-left: 1rem;\n}\n.pb-8 {\n  padding-bottom: 0.5rem;\n}\n.pd-16 {\n  padding: 1rem;\n}\n.pr-8 {\n  padding-right: 0.5rem;\n}\n.pr-8-i {\n  padding-right: 0.5rem !important;\n}\n.p-16 {\n  padding: 1rem;\n}\n.px-8 {\n  padding-left: 0.5rem;\n  padding-right: 0.5rem;\n}\n.px-16 {\n  padding-left: 1rem;\n  padding-right: 1rem;\n}\n\n.py-16 {\n  padding-top: 1rem;\n  padding-bottom: 1rem;\n}\n\n.pt-8 {\n  padding-top: 0.5rem;\n}\n\n.pt-16 {\n  padding-top: 1rem;\n}\n\n.d-inline-block {\n  display: inline-block;\n}\n.d-flex {\n  display: flex;\n}\n.flex-wrap {\n  flex-wrap: wrap;\n}\n.inline-flex {\n  display: inline-flex;\n}\n.flex-column-reverse {\n  flex-direction: column-reverse;\n}\n.flex-column {\n  flex-direction: column;\n}\n.align-center {\n  align-items: center;\n}\n.align-start {\n  align-items: flex-start !important;\n}\n\n.text-start {\n  text-align: start;\n}\n\n.text-center {\n  text-align: center;\n}\n\n.flex-center {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.child-flex-center > div {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mx-4 {\n  margin-left: 0.25rem;\n  margin-right: 0.25rem;\n}\n\n.w-full {\n  width: 100%;\n}\n\n.w-fit {\n  width: fit-content;\n}\n\n.min-w-fit {\n  min-width: fit-content;\n}\n\n.w-half {\n  width: 50%;\n}\n\n.h-full {\n  height: 100%;\n}\n\n.Polaris-TextField__Suffix {\n  margin: 0;\n  margin-right: 0.25rem;\n}\n\n.fw-500 {\n  font-weight: 500;\n}\n\n.disable-content {\n  opacity: 0.5;\n  pointer-events: none;\n}\n\n.border-top {\n  border-top: 1px solid #e7e7e7;\n}\n\n/* Editor image */\n.tox-browse-url {\n  display: none !important;\n}\n\n#emoji-close-div {\n  display: none !important;\n}\n\n.editor-icon-container {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.editor-icon {\n  display: flex;\n  justify-content: center;\n  padding: 4px;\n  margin: 4px;\n  width: 10%;\n  cursor: pointer;\n}\n.editor-icon .est-emoji {\n  height: 16px;\n  width: 16px;\n}\n.editor-emoji-icon {\n  color: #000;\n  font-feature-settings: 'clig' off, 'liga' off;\n  font-family: Inter;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 450;\n  line-height: 20px;\n  font-display: swap;\n}\nlabel {\n  font-weight: 450;\n}\n.note-group-select-from-files {\n  display: none;\n}\n\n.Polaris-Listbox-TextOption__Checkbox {\n  width: 100%;\n}\n\n.Polaris-Listbox-TextOption__Checkbox .Polaris-Choice.Polaris-Checkbox__ChoiceLabel {\n  width: 100%;\n}\n.Polaris-Listbox-TextOption__Checkbox .Polaris-Choice.Polaris-Checkbox__ChoiceLabel .Polaris-Choice__Label {\n  width: 100%;\n}\n\n.Polaris-Listbox-TextOption__Checkbox .Polaris-Choice.Polaris-Checkbox__ChoiceLabel .Polaris-Choice__Label > label {\n  width: 100%;\n}\n\n.highlight-border {\n  outline: 2px solid rgba(255, 184, 0, 0.56);\n  animation: highlight-border 1.5s linear infinite;\n  border-radius: 12px;\n}\n\n.bold-text-styled .Polaris-Text--root {\n  font-size: 0.95rem;\n}\n\n.font-bold {\n  font-weight: 700;\n}\n\n.ot-polaris-text-18 .Polaris-Text--root {\n  font-size: 18px;\n}\n\n.gap-4 {\n  gap: 0.25rem;\n}\n\n.gap-8 {\n  gap: 0.5rem;\n}\n\n.gap-12 {\n  gap: 0.75rem;\n}\n\n.gap-16 {\n  gap: 1rem;\n}\n\n.gap-24 {\n  gap: 1.5rem;\n}\n\n.text--gray {\n  color: var(--p-color-text-disabled);\n}\n\n#btn-destructive-tone {\n  background-color: var(--p-color-bg-fill-critical) !important;\n}\n\n#btn-destructive-tone:hover {\n  background-color: var(--p-color-bg-fill-critical-hover) !important;\n  color: #fff;\n}\n\n#btn-destructive-tone::before {\n  box-shadow: var(--p-shadow-button-primary-critical) !important;\n}\n\n@keyframes highlight-border {\n  0% {\n    outline-color: #fff;\n  }\n\n  25% {\n    outline-color: #ffb800;\n  }\n\n  75% {\n    outline-color: #fff;\n  }\n\n  to {\n    outline-color: #ffb800;\n  }\n}\n\n/* Timeline graphic stage */\n.inactive-stage {\n  opacity: 0.5;\n}\n\n.timeline-actived-tab .Polaris-Button--tertiary {\n  background-color: var(--pc-button-color-hover);\n}\n\n/* Text editor */\n\n.item-highlight-outline {\n  /* outline: 2px solid #005bd3; */\n  outline: 2px solid #65abff;\n  border-radius: 2px;\n  &.border-radius-8 {\n    border-radius: 8px;\n  }\n}\n\n.text-ellipsis {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  max-width: 500px;\n}\n\n.bg-gray {\n  background-color: #f0f0f0 !important;\n}\n\n@media (max-width: 768px) {\n  .text-ellipsis {\n    max-width: 70vw;\n  }\n}\n\n.Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge:has(#modal-cu-language-rule) {\n  width: 95vw;\n  max-width: unset;\n}\n\n@media (max-width: 768px) {\n  .Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge:has(#modal-cu-language-rule) {\n    width: 100vw;\n    max-width: unset;\n  }\n}\n\n.Polaris-Modal-Dialog__Modal.Polaris-Modal-Dialog--sizeLarge:has(#language-rule-modal-title) {\n  h2 {\n    width: 100%;\n  }\n}\n\n.Polaris-Modal-Dialog__Container:has(#editor-icon-container-id),\n.Polaris-Modal-Dialog__Container:has(#language-rule-modal-discard-container),\n.Polaris-Modal-Dialog__Container:has(#image-btn-in-editor),\n.Polaris-Modal-Dialog__Container:has(#link-btn-in-editor),\n.Polaris-Modal-Dialog__Container:has(#confirm-left-btn),\n.Polaris-Modal-Dialog__Container:has(#editor-tips-template-container-id),\n.Polaris-Modal-Dialog__Container:has(#confirm-auto-translate-content) {\n  z-index: 520;\n}\n\ndiv:has(.Polaris-Modal-Dialog__Container):has(#editor-icon-container-id) + .Polaris-Backdrop,\ndiv:has(.Polaris-Modal-Dialog__Container):has(#language-rule-modal-discard-container) + .Polaris-Backdrop,\ndiv:has(.Polaris-Modal-Dialog__Container):has(#image-btn-in-editor) + .Polaris-Backdrop,\ndiv:has(.Polaris-Modal-Dialog__Container):has(#link-btn-in-editor) + .Polaris-Backdrop,\ndiv:has(.Polaris-Modal-Dialog__Container):has(#confirm-left-btn) + .Polaris-Backdrop,\ndiv:has(.Polaris-Modal-Dialog__Container):has(#editor-tips-template-container-id) + .Polaris-Backdrop,\ndiv:has(.Polaris-Modal-Dialog__Container):has(#confirm-auto-translate-content) + .Polaris-Backdrop {\n  z-index: 519;\n}\n\nh2.Polaris-Text--root.Polaris-Text--headingMd.Polaris-Text--break:has(#cu-language-rule-modal-title) {\n  width: 100%;\n}\n\nli.Polaris-Listbox-Option[aria-label='Select all dates'] > div {\n  border-bottom: 1px solid #e0e0e0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
